<template>
  <header class="inner_banner">
    <div class="main_header">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light">
          <router-link class="navbar-brand" to="/"
            ><img src="../assets/images/logo.png" alt=""
          /></router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item active">
                <router-link class="nav-link" to="/">Home</router-link>
              </li>
              <li class="nav-item active">
                <router-link class="nav-link" to="/liquidity">Liquidity</router-link>
              </li>
              <li class="nav-item active">
                <router-link class="nav-link" to="/trades">Trades</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="how-it-works"
                  >How it works
                </router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="contact">Contact</router-link>
              </li>
              <li class="nav-item">
                <a class="nav-link" @click="connect()" v-if="!account"
                  >Connect to a Wallet</a
                >
                <span v-if="account" style="color: #fff">
                  <i
                    class="fa fa-circle"
                    style="color: #0eff0e; font-size: 10px; margin-right: 3px"
                  ></i
                  >{{ account | toShortAccount }}</span
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Header",
  computed: {
    ...mapGetters(["contracts", "erc20TokenContract", "account"]),
  },
  methods: {
    async connect() {
      await this.$store.dispatch("bootstrap");
    },
  },
};
</script>

<style scoped>
</style>
